import { Button, Checkbox, Col, Form, Input, message, Row, Select } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { IconCopy, IconRadioActive } from '../../../assets/index';
import BreadCrumbComponent from '../../../components/breadcrumb/BreadCrumbComponent';
import useBanner from '../../../hooks/useBanner';
import { routes } from '../../../utils/constants/constant';
import { isEmpty } from '../../../utils/helpers/helpers';
import '../Dashboard.scss';

const breadCrumbs = [
  {
    name: 'Trang chủ',
    isLink: false,
  },
  {
    name: 'Tổng quan',
    isLink: true,
    link: routes.DASHBOARD,
  },
  {
    name: 'Banner',
    isLink: false,
  },
];
const { Option } = Select;

const Banner = (props) => {
  // const [url, setUrl] = useState('');
  // const [isEdit, setIsEdit] = useState(false);
  // const [listBanner, setListBanner] = useState([]);
  // const [bannerSelected, setBannerSelected] = useState({});
  // const [aff_cid, setAff_cid] = useState('');
  // const [form] = Form.useForm();
  // const [listDomain, setListDomain] = useState([]);
  // useEffect(() => {
  //   fetListDomain();
  //   // eslint-disable-next-line
  // }, []);
  // const fetListDomain = async () => {
  //   try {
  //     const { data } = await getListDomain();
  //     if (data.code === 200) {
  //       setListDomain(data?.data?.items || []);
  //       const location = props?.location || {};
  //       if (!isEmpty(data?.data?.items) && isEmpty(location.search)) {
  //         form.setFieldsValue({
  //           affiliationDomainId: data?.data?.items[0].id,
  //         });
  //       }
  //     }
  //   } catch (error) {}
  // };
  // useEffect(() => {
  //   const affiliationBanners = props?.generalInfo?.affiliationBanners || [];
  //   const location = props?.location || {};
  //   if (!isEmpty(location.search)) {
  //     const search = location.search;
  //     const params = new URLSearchParams(search);
  //     const aff_cid = params.get('aff_cid');
  //     if (!isEmpty(aff_cid)) {
  //       handleFetCampaignDetail(aff_cid, affiliationBanners);
  //     } else {
  //       setBannerFirst(affiliationBanners);
  //     }
  //   } else {
  //     setBannerFirst(affiliationBanners);
  //   }
  //   // eslint-disable-next-line
  // }, [props.generalInfo]);

  // const handleFetCampaignDetail = async (aff_cid, affiliationBanners = []) => {
  //   const { data } = await getCampaign(aff_cid);
  //   if (data.code === 200) {
  //     const dataRes = data?.data || {};
  //     const bannersSize = affiliationBanners.find(
  //       (el) => el.size === dataRes?.banner?.size
  //     );
  //     setListBanner(bannersSize?.banners || []);
  //     setAff_cid(aff_cid);
  //     setIsEdit(true);
  //     setUrl(dataRes?.sharingContent);
  //     setBannerSelected(dataRes?.banner);
  //     form.setFieldsValue({
  //       campaignName: dataRes.name || '',
  //       bannerSize: dataRes?.banner?.size,
  //       affiliationDomainId: dataRes.affiliationDomainId || '',
  //       specificLink: dataRes.specificLink || '',
  //       isCheckSpecificLink: !isEmpty(dataRes.specificLink),
  //     });
  //   }
  // };

  // const setBannerFirst = (affiliationBanners) => {
  //   if (!isEmpty(affiliationBanners)) {
  //     let bannerSelected = affiliationBanners[0];
  //     const bannerFind250 =
  //       affiliationBanners.find((el) => el.size === '250 x 250') || {};
  //     if (!isEmpty(bannerFind250)) {
  //       bannerSelected = bannerFind250;
  //     }
  //     form.setFieldsValue({
  //       bannerSize: bannerSelected.size || '',
  //     });
  //     const banners = bannerSelected?.banners || [];
  //     setListBanner(banners || []);
  //     if (!isEmpty(banners)) {
  //       setBannerSelected(banners[0]);
  //     }
  //   }
  // };

  // const onFinish = async (values) => {
  //   try {
  //     let dataDTO = {
  //       affiliationType: 'banner',
  //       campaignName: values.campaignName,
  //       bannerId: bannerSelected.id,
  //       affiliationDomainId: values.affiliationDomainId,
  //     };
  //     if (
  //       listDomain.find((el) => el.id === values.affiliationDomainId)
  //         ?.allowSpecificLink
  //     ) {
  //       if (values.isCheckSpecificLink) {
  //         dataDTO = { ...dataDTO, specificLink: values.specificLink };
  //       }
  //     }
  //     if (isEdit) {
  //       dataDTO = {
  //         ...dataDTO,
  //         id: aff_cid,
  //       };
  //     }
  //     let dataRes = {};
  //     if (isEdit) {
  //       const { data } = await updateCampaign(dataDTO);
  //       dataRes = data;
  //     } else {
  //       const { data } = await createCampaign(dataDTO);
  //       dataRes = data;
  //     }
  //     if (dataRes.code === 200) {
  //       setUrl(dataRes.data.sharingContent);
  //       message.success(
  //         `${isEdit ? 'Chỉnh sửa' : 'Tạo mới'} campaign thành công!`
  //       );
  //     } else {
  //       message.error('Đã có lỗi xảy ra vui lòng thử lại sau');
  //     }
  //   } catch (error) {}
  // };

  // const onFinishFailed = (errorInfo) => {};

  // const onBannerChange = (value = '') => {
  //   setUrl('');
  //   const affiliationBanners = props?.generalInfo?.affiliationBanners || [];
  //   if (!isEmpty(affiliationBanners)) {
  //     const bannerSeizeSelect = affiliationBanners.find(
  //       (el) => el.size === value
  //     );
  //     if (!isEmpty(bannerSeizeSelect)) {
  //       const banners = bannerSeizeSelect?.banners || [];
  //       setListBanner(banners || []);
  //       if (!isEmpty(banners)) {
  //         setBannerSelected(banners[0]);
  //       }
  //     }
  //   }
  // };

  // const getSpan = (size = '120 x 600') => {
  //   switch (size) {
  //     case '728 x 90':
  //       return 24;
  //     case '468 x 80':
  //       return 12;
  //     case '300 x 250':
  //       return 8;
  //     default:
  //       return 6;
  //   }
  // };
  const {
    getSpan,
    setUrl,
    url,
    listBanner,
    setBannerSelected,
    bannerSelected,
    form,
    listDomain,
    onFinish,
    onFinishFailed,
    onBannerChange,
  } = useBanner({ ...props });
  return (
    <div className='container-home container-banner'>
      <BreadCrumbComponent breadCrumbs={breadCrumbs} />
      <div className='title-container-home'>Banner</div>
      <div className='des-container-banner'>
        Chọn một banner của Mytour để phù hợp với website của bạn và đặt vào
        trang nội dung của bạn. 4 loại banner có 6 định dạng khác nhau để phù
        hợp với nội dung bất kỳ.
      </div>
      <Form
        form={form}
        hideRequiredMark
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        className='banner-form'
        layout='vertical'
        initialValues={{
          campaignName: undefined,
          affiliationDomainId: undefined,
          isCheckSpecificLink: false,
          specificLink: undefined,
        }}
      >
        <Form.Item
          label='Tên chiến dịch'
          name='campaignName'
          rules={[
            {
              required: true,
              message: 'Vui lòng nhập tên chiến dịch',
            },
          ]}
        >
          <Input
            placeholder='Nhập tên chiến dịch'
            className='input-banner-form'
            onChange={({ target: { value } }) => {
              setUrl('');
            }}
          />
        </Form.Item>
        <div className='input-website'>
          <Form.Item
            name='affiliationDomainId'
            label='Nền tảng'
            className='select-domain'
            rules={[{ required: true, message: 'Vui lòng chọn nền tảng' }]}
          >
            {!isEmpty(listDomain) && (
              <Select
                onChange={() => {
                  setUrl('');
                }}
              >
                {listDomain?.map((el) => (
                  <Option value={el.id}>{el.domain}</Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </div>
        <Form.Item
          shouldUpdate={(prevValues, curValues) =>
            prevValues.affiliationDomainId !== curValues.affiliationDomainId
          }
          className='request-image-item'
          style={{ marginBottom: 0 }}
        >
          {() => (
            <>
              {listDomain.find(
                (el) => el.id === form.getFieldValue('affiliationDomainId')
              )?.allowSpecificLink && (
                <>
                  <div className='input-website'>
                    <Form.Item
                      name='isCheckSpecificLink'
                      className='is-check-specific-link'
                      valuePropName='checked'
                    >
                      <Checkbox
                        onChange={() => {
                          setUrl('');
                        }}
                      >
                        Đường dẫn trực tiếp tới sản phẩm
                      </Checkbox>
                    </Form.Item>
                  </div>
                  <Form.Item
                    shouldUpdate={(prevValues, curValues) =>
                      prevValues.isCheckSpecificLink !==
                      curValues.isCheckSpecificLink
                    }
                    className='request-image-item'
                  >
                    {() => {
                      return (
                        <>
                          {form.getFieldValue('isCheckSpecificLink') && (
                            <div className='input-website'>
                              <Form.Item
                                name='specificLink'
                                className='specific-link'
                                rules={[
                                  {
                                    required: form.getFieldValue(
                                      'isCheckSpecificLink'
                                    ),
                                    message:
                                      'Vui lòng nhập đường dẫn trực tiếp tới sản phẩm',
                                  },
                                ]}
                                style={{ marginBottom: 0 }}
                              >
                                <Input
                                  placeholder='Ví dụ: https://mytour.vn/khach-san/1223-khach-san-sofitel-plaza-sai-gon...'
                                  onChange={({ target: { value } }) => {
                                    setUrl('');
                                  }}
                                />
                              </Form.Item>
                            </div>
                          )}
                        </>
                      );
                    }}
                  </Form.Item>
                </>
              )}
            </>
          )}
        </Form.Item>
        <Form.Item name='bannerSize' label='Kích thước Banner'>
          {!isEmpty(props?.generalInfo) && (
            <Select onChange={onBannerChange} className='input-banner-form'>
              {props?.generalInfo?.affiliationBanners?.map((el) => (
                <Option value={el.size}>{el.size}</Option>
              ))}
            </Select>
          )}
        </Form.Item>
        <Row className='list-banner-for-size'>
          {listBanner.map((el) => (
            <Col
              onClick={() => {
                setUrl('');
                setBannerSelected(el);
              }}
              key={el.id}
              className={`item-banner ${
                bannerSelected.id === el.id ? 'item-banner-select' : ''
              }`}
              span={getSpan(el.size)}
            >
              <img src={el.link} alt='img_banner' />
              {bannerSelected.id === el.id && (
                <div className='icon-select'>
                  <IconRadioActive />
                  <span style={{ paddingLeft: 4 }}>Đã chọn</span>
                </div>
              )}
            </Col>
          ))}
        </Row>
        <Form.Item style={{ marginBottom: '16px' }}>
          <Button type='primary' htmlType='submit' className='submit-save'>
            Lưu và tạo mã
          </Button>
        </Form.Item>
      </Form>
      {url && (
        <div className='content-url'>
          <div className='content-url-header'>
            <span>URL</span>
            <span
              className='wrap-copy'
              onClick={() => {
                navigator.clipboard.writeText(url);
                message.success('Sao chép mã thành công!');
              }}
            >
              <div className='icon-copy'>
                <IconCopy />
              </div>
              Sao chép mã
            </span>
          </div>
          <div className='url'>{url}</div>
        </div>
      )}
    </div>
  );
};

export default connect(
  (state) => ({
    profile: state.systemReducer.profile,
    generalInfo: state.systemReducer.generalInfo,
  }),
  {}
)(withRouter(Banner));
